<template>
  <div class="big-image" :data-theme="getRouteName !== 'home' ? false : getCity === 'amsterdam' ? 'pink' : 'blue'" data-cont="small">
    <BasePicture
      class="big-image__picture"
      :data="Object.assign(data, { tagImg: false })"
      :lottieBg="'large'"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BasePicture from '@/components/BasePicture';


export default {
  name: 'bigImage',

  components: {
    BasePicture,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters(['getRouteName', 'getCity']),
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/utils";

.big-image {
  position: relative;
  width: 100%;

  .ui-container {
    position: relative;
    width: 100%;
  }

  &__picture {
    position: relative;
    width: 100%;
    margin: 40px 0;

    @include mq(ipadP) {
      margin: 80px 0;
    }

    @include aspect-ratio(2, 1);

    @include mq(mobile, $and: $is-portrait) {
      @include aspect-ratio(1, 1.2);
    }

    @include mq(ipadP) {
      @include aspect-ratio(2, 1);
    }
  }

  button {
    position: absolute;
    top: calc(50% - 45px);
    left: 50%;

    transform: translate3d(-50%, -50%, 0) scale(1);
    transition: transform 0.3s $global-ease;
    transform-origin: 50% 50%;
    backface-visibility: hidden;

    @at-root .pointerevents:not(.touchevents) &:hover,
    .no-pointerevents.no-touchevents &:hover {
      transform: translate3d(-50%, -50%, 0) scale(0.9);
    }

    cursor: pointer;
  }
}
</style>
